import { Component, OnInit, OnDestroy } from '@angular/core';
import { ReportingService } from '../reporting.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { LoginSettings } from '../../login/LoginSetting.model';
import { YearService } from '../../../shared-components/year/year.service';
import { Report } from '../models/report.model';
import { ReportFolder } from '../models/report-folder.model';
import { ReportModule } from '../models/report-module.model';
import { ReportParametersComponent } from '../parameters/report-parameters.component';
import { ReportSettingsFoldersComponent } from '../report-settings/report-settings.folders.component';
import { ReportOptionsComponent } from '../definitions/report-options.component';
import { LoginService } from '../../login/login.service';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { ReportSettingsAutoRunComponent } from '../report-settings/report-settings-autorun.component';
import { ReportAutoRunMessageComponent } from '../report-settings/report-autorun-message.component';

export const enum OneSisModule {
  All = 0
  // Classroom360 = 2,
  // Student360 = 4,
  // Counselor360 = 3
}

@AutoUnsubscribe()
@Component({
  selector: 'allReports',
  templateUrl: './all-reports.component.html',
  styleUrls: ['./all-reports.component.css']

  // entryComponents: [
  //     ]
})

export class AllReportsComponent implements OnInit, OnDestroy {

  loginSettings: LoginSettings;
  utilizeDistributebyEmail: boolean;
  expandedRows: boolean[] = [];
  ReportFolders: ReportFolder[] = [];
  myReportFolders: ReportFolder[] = [];
  folderIds: number[] = [];
  reportIds: number[] = [];
  Reports: Report[];
  ReportModules: ReportModule[] = [];
  selectedReportModule: number;
  angularMatData = new MatTableDataSource;
  //   columnsToDisplay: string[] = ['ReportName', 'Type', 'AutoRun', 'MyReports', 'Actions'];
  columnsToDisplay: string[] = ['ReportName', 'AutoRun', 'MyReports', 'Actions'];
  useReportDefinitions: boolean;
  SelectedReport: Report;
  reportParametersDialogRef: MatDialogRef<ReportParametersComponent>;
  reportSettingsDialogRef: MatDialogRef<ReportSettingsFoldersComponent>;
  reportSettingsAutoRunDialogRef: MatDialogRef<ReportSettingsAutoRunComponent>;
  reportOptionsDialogRef: MatDialogRef<ReportOptionsComponent>;
  reportAutoRunMessageDialogRef: MatDialogRef<ReportAutoRunMessageComponent>;
  // reportsMode: number; // enum: MyReports = 1, AllReports = 2
  reportSearch: string;
  showSearchMessage: boolean;
  allowAutoRunReport: boolean;

  selectedSchoolId: number;

  private _moduleId: number;
  filterValue: string;
  showReportToPDF = false;

  // get oneSisModules(): ReportModule[] {
  //   return this.reportService.oneSisModules;
  // }

  // set oneSisModules(value: ReportModule[]) {
  //   this.reportService.oneSisModules = value;
  // }

  constructor(
    private reportService: ReportingService,
    private loginService: LoginService,
    private dialog: MatDialog,
    private reportSettingsDialog: MatDialog,
    private reportSettingsAutoRunDialog: MatDialog,
    private reportOptionsDialog: MatDialog,
    private reportAutoRunMessageDialog: MatDialog,
    private yearService: YearService,

  ) {

    this.loginSettings = loginService.LoginSettings;
    this.utilizeDistributebyEmail = this.loginSettings.UtilizeDistributebyEmail;
    this.allowAutoRunReport = this.reportService.allowAutoRunReport;
    this.selectedSchoolId = this.yearService.defaultYear.SchoolID;
    this.useReportDefinitions = reportService.useReportDefinitions;
    // Load data into a DataSource object
    // MatTableDataSource extends DataSource to allow sorting, pagination and basic filtering
    // TylerMatTableDataSource extends MatTableDataSource and allows complex filtering and detail rows
    this.angularMatData = new MatTableDataSource(this.Reports);


  } // end constructor

  ngOnInit() {
    // this.populateReportModules();

    this.getReportModulesByRole(true);
    // const allReportsFolder = new ReportFolder();

    // allReportsFolder.Id = 0;
    // allReportsFolder.IsDetailRowExpanded = true;
    // allReportsFolder.Name = 'All Reports';
    // allReportsFolder.Reports = [];
    // this.ReportFolders.push(allReportsFolder);

    // if (this.reportService.inDebugMode) {
    //   console.log('this.selectedSchoolId:' + this.selectedSchoolId);
    // }

    this.getAllReports(OneSisModule.All, this.selectedSchoolId);

    // getting My reports now due to folder and auto run settings being
    // accessable from the all reports page
    // this.getMyReportFolders();

  }

  ngOnDestroy() { }

  // filter material table
  applyFilter(filterValue: string) {

    this.angularMatData.filter = filterValue.trim().toLowerCase();

    // this.loadReportData()

    // if (this.reportService.inDebugMode) {
    //   console.log('applyFilter()');
    //   console.log(this.angularMatData);
    // }
  }

  loadReportData(): void {
    // load data into Angular Material table
    this.angularMatData.data = this.Reports;
    // if (this.reportService.inDebugMode) {
    //   console.log('loadReportData()');
    // }
  }

  getReportModulesByRole(isInit: boolean) {
    // const selectedSchoolDomain = this.yearService.defaultYear.SchoolID;
    this.reportService.getReportModulesByRole(this.selectedSchoolId).subscribe(reportModules => {

      // if (this.reportService.inDebugMode) {
      //   console.log(reportModules);
      // }

      // clear the array
      this.ReportModules.length = 0;

      if (reportModules.length > 1) {
        // then need to add ALL
        const allReportsReportModule = new ReportModule();
        allReportsReportModule.ID = 0;
        allReportsReportModule.Description = 'All';
        allReportsReportModule.IsSelected = true;
        reportModules.unshift(allReportsReportModule); // push it to the fromt of the array
      }

      // for (let i; i < reportModules.length; i++) {
      //   this.ReportModules.push(reportModules[i]);
      // }

      if (reportModules.length > 0) {
        reportModules[0].IsSelected = true;
        this.selectedReportModule = reportModules[0].ID;
      }
      // this.selectedReportModule = OneSisModule.All;

      this.ReportModules = reportModules;
      // this.reportService.oneSisModules = reportModules;

      // if (this.reportService.inDebugMode) {
      //   console.log(reportModules);
      //   console.log(this.ReportModules);

      // }

      // this.ReportModules = this.oneSisModules;

      if (isInit) {
        this.getMyReportFolders();
      }


    });
  }


  // private populateReportModules() {

  //   if (this.reportService.inDebugMode) {
  //     console.log('In populateReportModules()');
  //   }

  //   // const enum reportModule {
  //   //   All = 0,
  //   //   Classroom360 = 1,
  //   //   Student360 = 2
  //   // }

  //   this.showReportToPDF = false; // ????


  //   // const allReportsReportModule = new ReportModule();
  //   // allReportsReportModule.ID = OneSisModule.All;
  //   // allReportsReportModule.Description = 'All';
  //   // allReportsReportModule.IsSelected = true;
  //   // this.ReportModules.push(allReportsReportModule);

  //   // const classroom360ReportModule = new ReportModule();
  //   // classroom360ReportModule.ID = OneSisModule.Classroom360;
  //   // classroom360ReportModule.Description = 'Classroom';
  //   // classroom360ReportModule.IsSelected = false;
  //   // this.ReportModules.push(classroom360ReportModule);

  //   // const student360ReportModule = new ReportModule();
  //   // student360ReportModule.ID = OneSisModule.Student360;
  //   // student360ReportModule.Description = 'Student';
  //   // student360ReportModule.IsSelected = false;
  //   // this.ReportModules.push(student360ReportModule);

  //   // const counselor360ReportModule = new ReportModule();
  //   // counselor360ReportModule.ID = OneSisModule.Counselor360;
  //   // counselor360ReportModule.Description = 'Counselor';
  //   // counselor360ReportModule.IsSelected = false;
  //   // this.ReportModules.push(counselor360ReportModule);

  //   // this.ReportModules = this.reportService.oneSisModules;

  //   // this.selectedReportModule = OneSisModule.All; // defaults to ALL
  // }


  reportSettingsClick(report: Report) {
    this.reportService.SelectedReport = report;
    this.reportService.ReportFolders = this.myReportFolders;

    this.reportSettingsDialogRef = this.reportSettingsDialog.open(ReportSettingsFoldersComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true
    });

    this.reportSettingsDialogRef.afterClosed().subscribe(result => {

      if (result > '') {

        // refresh folder list for next use of report folder settings
        this.getMyReportFolders();

        // refresh folder list on all reports page
        this.getAllReports(OneSisModule.All, this.selectedSchoolId);
        // this.ReportFolders = this.reportService.ReportFolders;
      }
      // if (this.reportService.inDebugMode) {
      //   console.log('AllReportsComponent =>reportSettingsDialogRef.afterClosed()');
      // }
    });
  }

  autorunSettingsClick(report: Report) {
    this.reportService.SelectedReport = report;
    this.reportService.ReportFolders = this.ReportFolders;
    this.reportService.isForSchedule = true;

    // check that  allowAutoRunReport (system) and AllowAutoRun(report and that report is in a folder
    // if not, show message
    if (this.allowAutoRunReport == false || report.AllowAutoRun == false || report.ReportFolder == '') {
      this.reportAutoRunMessageDialogRef = this.reportAutoRunMessageDialog.open(ReportAutoRunMessageComponent, {
        panelClass: 'tyl-mat-dialog',
        disableClose: true
      });
      return;
    }


    // call report params load and pop up and show autorun setting within

    // we will need to determine if this is a new or existing autorun when populating parameters

    let isExistingAutorun = false;
    if (report.AutoRunSchedule_ID > 0) {
      // pull saved parameters
      isExistingAutorun = true;
    }

    this.reportService.getReportParameters(-1, report, isExistingAutorun).subscribe(selectedReport => {

      // if (this.reportService.inDebugMode) {
      //   console.log(selectedReport);
      // }

      this.reportService.SelectedReport = selectedReport;
      this.openReportParametersWindow();

    });
  }

  reportOptionsClick(report: Report) {
    this.reportService.SelectedReport = report;
    this.reportService.isFromMenu = true;
    // this.reportService.ReportFolders = this.myReportFolders;

    this.reportOptionsDialogRef = this.reportOptionsDialog.open(ReportOptionsComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true
    });

    this.reportOptionsDialogRef.afterClosed().subscribe(result => {

      // if (this.reportService.inDebugMode) {
      //   console.log('AllReportsComponent =>reportOptionsDialogRef.afterClosed()');
      // }

      // if (result > '') {
      //   this.getMyReportFolders();
      // }

    });

  }

  getMyReportFolders(): void {
    this.reportService.getMyReportFolders().subscribe(reportFolders => {
      this.reportService.ReportFolders = reportFolders;
      this.myReportFolders = reportFolders;

      // this.expandAllRows(-1, true);

      // if (this.reportService.inDebugMode) {
      //   console.log('AllReportsComponent =>  reportService.ReportFolders: ' + this.reportService.ReportFolders.length);
      //   console.log('AllReportsComponent =>  getMyReportFolders() - Report Folder(s) below');
      //   console.log(this.reportService.ReportFolders);
      // }
    });
  }


  getAllReports(moduleId: number, schoolId: number): void {
    schoolId = this.selectedSchoolId;
    this.reportService.getAllReports(moduleId, schoolId).subscribe(reports => {

      // if (this.reportService.inDebugMode) {
      //   console.log(reports);
      //   console.log(this.ReportFolders);
      // }


      // this.ReportFolders[0].Reports = reports;
      this.Reports = reports;
      this.reportService.ReportFolders = this.ReportFolders;


      // if (this.reportService.inDebugMode) {
      //   console.log('AllReportsComponent =>  SelectFolders length: ' + this.reportService.ReportFolders.length);
      //   console.log('AllReportsComponent =>  folderIds: ' + this.folderIds);
      //   console.log('AllReportsComponent =>  reportIds: ' + this.reportIds);
      //   console.log(this.ReportFolders);




      // }

      this.loadReportData();
      // if (this.reportService.inDebugMode) {
      //   console.log('AllReportsComponent =>  angularMatData');
      //   console.log(this.angularMatData);

      // }
    });
  }

  selectFolder(folderID) {

    // if (this.reportService.inDebugMode) {
    //   console.log('AllReportsComponent =>  selectFolder(' + folderID + ')');
    // }

  }

  reportClicked(report) {
    // if (this.reportService.inDebugMode) {
    //   console.log('AllReportsComponent =>  reportClicked(' + report.Name + ', IsSysGen=' + report.IsSysGen + ')');
    // }

    this.reportService.isFromMenu = false;

    this.reportService.getReportParameters(-1, report).subscribe(selectedReport => {

      // if (this.reportService.inDebugMode) {
      //   console.log(selectedReport);
      // }

      this.reportService.SelectedReport = selectedReport;
      this.openReportParametersWindow();

    });

  }


  openReportParametersWindow() {
    this.reportParametersDialogRef = this.dialog.open(ReportParametersComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true
    });

    // this.reportParametersDialogRef.beforeClose().subscribe(result => {
    //   if (this.reportService.inDebugMode) {
    //     console.log('shared/HeaderComponent =>reportsDialogRef.beforeClose()');
    //   }
    // });

    // this.reportParametersDialogRef.afterClosed().subscribe(result => {
    //   if (this.reportService.inDebugMode) {
    //     console.log('shared/HeaderComponent =>reportsDialogRef.afterClosed()');
    //   }
    // });


  }




  isEven(folderId) {
    return (folderId % 2) === 0;
  }


  closeClick() {

    // this.reportParametersDialogRef.close();
    // this.reportService.close();
  }



  getReports(moduleId: number) {

    // console.log(moduleId);
    this.getAllReports(moduleId, this.selectedSchoolId);


  }

  filterReports(report) {
    if (this.reportSearch == '' || this.reportSearch == '%') {
      return true;
    }
    else {
      if (this.reportSearch.charAt(0) == '"' && this.reportSearch.charAt(this.reportSearch.length - 1) == '"') {
        return this.reportSearch.toLowerCase().substring(1, this.reportSearch.length - 1) == report.Name.toLowerCase();
      }
      else {
        const searchTerm = this.reportSearch + '%';
        return new RegExp('^' + searchTerm.toLowerCase().split('%').join('.*') + '$').test(report.Name.toLowerCase());
      }
    }

  }

  setSearchMessageVisible(showSearchMessage: boolean) {

    // if (this.reportService.inDebugMode) {
    //   console.log('setSearchMessageVisible');
    //   console.log(showSearchMessage);
    // }
    this.showSearchMessage = !this.showSearchMessage;
  }




  searchReport() {

    // if (this.reportService.inDebugMode) {
    //   console.log();
    // }

    this.showSearchMessage = !this.showSearchMessage;


  }


  clearSearchReport() {
    // this.reportFilter.reportSearch = '';
    // this.searchReport();
    // this.IsReportSearch = false;
    // if (this.reportService.inDebugMode) {
    //   console.log('AllReportComponent.ts => clearSearchReport()');
    // }
  }

  expandAll(expand) {

    // if (this.reportService.inDebugMode) {
    //   console.log('AllReportComponent.ts => expandAllClick( ' + expand + ')');
    //   console.log('ReportFolders: ' + this.ReportFolders);
    //   console.log('expandedRows: ' + this.expandedRows);
    // }



  }

} // end export class MyReports




